import { Component, Input, OnInit } from '@angular/core';
import { MemberCard, MemberCardQuery } from '@fgb/core';
import { Observable } from 'rxjs';
import { ProductCode } from 'src/app/shared/utilities/product-code';

@Component({
  selector: 'fgb-banner',
  templateUrl: './banner.component.html',
  styleUrl: './banner.component.scss',
})
export class BannerComponent implements OnInit {
  @Input() pageTitle: string = '';
  @Input() memberName: string = '';
  @Input() isHomeBanner: boolean = false;
  productCode = ProductCode;
  memberCard$: Observable<MemberCard | undefined>;

  constructor(private memberCardQuery: MemberCardQuery) {}

  ngOnInit(): void {
    this.memberCard$ = this.memberCardQuery.selectCurrentCard();
  }
}
